import { createSlice } from "@reduxjs/toolkit";
import hit from "../services/manager";
import { setToast } from "./toast";


const initialState={
    authorize:false,
    user:null
}

const authSlice=createSlice({
    name:"auth",
    initialState:initialState,
    reducers:{
        setAuthorize:(state,action)=>{
            console.log("action",action);
            state.authorize=action.payload
        },
        setUser:(state,action)=>{
            state.user=action.payload
        },
        clearAuthData:(state,action)=>{
            return initialState
        }
    }
})

export const {setAuthorize,setUser,clearAuthData}=authSlice.actions


export const getUserDataThunk=()=>{
    return async(dispatch)=>{
        try{
            const res= await hit("/users/self","get")
            if(!res.err){
                dispatch(setUser(res.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load your profile", severity: "error" }))
            }
        }catch(err){
            dispatch(setToast({ show: true, message: "Failed to load your profile", severity: "error" }))
        }
    }
}

export default authSlice.reducer